<template>
  <base-modal :id="id" :closeVisible="closeVisible">
    <template>
      <h5>{{ $t('resetPasswordModal.title') }}</h5>
      <div class="separator"></div>
      <p class="description" v-if="$route.path === '/forgot-password'">{{ $t('resetPasswordModal.description') }}</p>
      <p class="description" v-else></p>
      <form @submit.prevent="resetPassword">
        <div class="form-group">
          <label for="current-password" class="text-uppercase input-label">{{ $t('resetPasswordModal.currentPasswordTitle') }}</label>
          <div class="input-group">
            <input id="current-password" :type="currentPasswordVisible ? 'text' : 'password'" class="form-control" required v-model="data.attributes.current_password" autocomplete="new-password">
            <div class="input-group-append" @click="currentPasswordVisible = !currentPasswordVisible">
              <span class="input-group-text"><font-awesome-icon :icon="currentPasswordVisible ? ['far', 'eye'] : ['far', 'eye-slash']"></font-awesome-icon></span>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="password" class="text-uppercase input-label">{{ $t('resetPasswordModal.newPasswordTitle') }}</label>
          <div class="input-group">
            <input id="password" :type="passwordVisible ? 'text' : 'password'" class="form-control" required v-model="data.attributes.password" autocomplete="new-password">
            <div class="input-group-append" @click="passwordVisible = !passwordVisible">
              <span class="input-group-text"><font-awesome-icon :icon="passwordVisible ? ['far', 'eye'] : ['far', 'eye-slash']"></font-awesome-icon></span>
            </div>
          </div>
          <p class="password-requirements">{{ $t('resetPasswordModal.newPasswordRequirements') }}</p>
        </div>
        <div class="form-group">
          <label for="password-confirmation" class="text-uppercase input-label">{{ $t('resetPasswordModal.newPasswordConfirmationTitle') }}</label>
          <div class="input-group">
            <input id="password-confirmation" :type="passwordConfirmationVisible ? 'text' : 'password'" class="form-control" required v-model="data.attributes.password_confirmation" autocomplete="new-password">
            <div class="input-group-append" @click="passwordConfirmationVisible = !passwordConfirmationVisible">
              <span class="input-group-text"><font-awesome-icon :icon="passwordConfirmationVisible ? ['far', 'eye'] : ['far', 'eye-slash']"></font-awesome-icon></span>
            </div>
          </div>
        </div>
        <div class="form-group mb-5">
          <button type="submit" class="btn btn-block float-right submit-button">{{ $t('resetPasswordModal.confirm') }}</button>
        </div>
      </form>
    </template>
  </base-modal>
</template>

<script>
import {
  createApi,
} from '@/services/api.service';
import BaseModal from '@/components/base-modal/base-modal.vue';
import { mapState } from 'vuex';
import common from "@/mixins/common";

export default {
  name: 'ResetPasswordModal',
  mixins: [common],
  components: {
    BaseModal,
  },
  data() {
    return {
      currentPasswordVisible: false,
      passwordVisible: false,
      passwordConfirmationVisible: false,
      data: {
        attributes: {
          current_password: null,
          password: null,
          password_confirmation: null,
        },
      },
    };
  },
  props: {
    id: String,
    closeVisible: Boolean,
    redirectHome: Boolean,
  },
  computed: {
    ...mapState(['currentUser']),
  },
  methods: {
    resetPassword() {
      if (this.validatePassword()) {
        createApi(`users/${this.currentUser.data.id}/change_password`, { data: this.data })
          .then(() => {
            this.$notify({
              text: 'Password has successfully been updated.',
              type: 'success',
            });
            if (!this.redirectHome) {
              this.data.attributes.password = '';
              this.data.attributes.current_password = '';
              this.data.attributes.password_confirmation = '';
              this.closeModal(this.id);
            } else {
              this.safelyNavigateToPath('Home');
            }
          })
          .catch((error) => {
            if (error.response && error.response.data) {
              if (error.response.status === 400 && error.response.data.errors[0].source.pointer === '/data/attributes/current_password') {
                this.$notify({
                  text: 'Current password is incorrect. Please try again.',
                  type: 'error',
                  width: 350,
                });
              }
            }
          });
      }
    },
    validatePassword() {
      let regex = new RegExp('[A-Z]+');
      if (!regex.test(this.data.attributes.password)) {
        this.displayErrorMessage('Password must contain at least 1 upper case letter.');
        return false;
      }

      regex = new RegExp('[a-z]');
      if (!regex.test(this.data.attributes.password)) {
        this.displayErrorMessage('Password must contain at least 1 lower case letter.');
        return false;
      }

      regex = new RegExp('[0-9]+');
      if (!regex.test(this.data.attributes.password)) {
        this.displayErrorMessage('Password must contain at least 1 number.');
        return false;
      }

      if (this.data.attributes.password.length < 8) {
        this.displayErrorMessage('Password must be 8 or more characters.');
        return false;
      }

      if (this.data.attributes.password !== this.data.attributes.password_confirmation) {
        this.displayErrorMessage('Password and Password Confirmation need to match.');
        return false;
      }
      return true;
    },
    displayErrorMessage(message) {
      this.$notify({
        text: message,
        type: 'error',
      });
    },
  },
};
</script>

<style scoped lang="scss" src="./styles.scss">
</style>
